interface IEDUCATION_INVESTMENT_FORMULA {
  presentCostOfEducation: number;
  expectedInflationRate: number;
  currentAgeOfChild: number;
  futureAgeOfChild: number;
  expectedRateOfReturn: number;
  amountSaved: number;
}

export function EDUCATION_INVESTMENT_FORMULA({
  presentCostOfEducation,
  expectedInflationRate,
  currentAgeOfChild,
  futureAgeOfChild,
  expectedRateOfReturn,
  amountSaved,
}: IEDUCATION_INVESTMENT_FORMULA) {
  const valueOfCurrentInvestments = amountSaved;
  const numberOfYearsRemaining = futureAgeOfChild - currentAgeOfChild;
  const expectedInflation = expectedInflationRate / 100;
  const expectedReturns = expectedRateOfReturn / 100;

  // Calculate Future Value of Education
  const estimatedFutureCostOfEducation =
    presentCostOfEducation *
    Math.pow(1 + expectedInflation, numberOfYearsRemaining);

  // Calculate Future Value of Current Investments
  const futureValueOfCurrentInvestments =
    valueOfCurrentInvestments *
    Math.pow(1 + expectedReturns, numberOfYearsRemaining);

  // Calculate Amount to Plan For
  const amountToPlanFor =
    estimatedFutureCostOfEducation - futureValueOfCurrentInvestments;

  // Calculate Monthly Investment Needed
  const monthlyInvestmentNeeded = calculateInvestmentRequiredPerMonth(
    amountToPlanFor,
    expectedReturns,
    12 * numberOfYearsRemaining
  );

  return {
    futureValueOfEducationCost: estimatedFutureCostOfEducation.toFixed(2),
    futureValueOfPresentInvestment: futureValueOfCurrentInvestments.toFixed(2),
    balanceAmount: amountToPlanFor.toFixed(2),
    monthlyInvestment:
      monthlyInvestmentNeeded > 0 ? monthlyInvestmentNeeded.toFixed(2) : 0,
    messageEnoughWealth:
      futureValueOfCurrentInvestments >= estimatedFutureCostOfEducation
        ? `You're doing well. You've enough wealth to meet your child's education expenses. Continue your investments in mutual funds.`
        : '',
  };
}

function calculateInvestmentRequiredPerMonth(FV: number, R: number, N: number) {
  if (R === 0) {
    return FV / N;
  }
  // Convert annual rate of return to monthly rate
  const monthlyRate = R / 12;
  // Calculate the investment required per month
  const investmentPerMonth =
    (FV * monthlyRate) / (Math.pow(1 + monthlyRate, N) - 1);
  return investmentPerMonth;
}
